<template>
	<component :is="dynamicComponent"></component>
</template>

<script>
	export default {
		name: 'Archive',
		data() {
			return {
				dynamicComponent: null,
				gameData: this.$store.state.gameData
			};
		},
		mounted() {
			this.loadComponent();
		},
		methods: {
			async loadComponent() {
				const {
					default: component
				} = await import('@/views/archive/' + this.gameData.language + '/archive.vue');
				this.dynamicComponent = component;
			}
		}
	}
	
</script>

<style scoped>
	.archive {
		text-indent: 3ch;
		padding: 5px 10px;
		font-size: 16px;
	}
</style>